// ==== Enums ====
export const EMarginScreens = {
  APPLICATION_STATUS: "applicationStatusForm",
  WELCOME: "welcome",
};
